var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "stats" },
    [
      _vm.$route.fullPath
        ? _c(
            "v-card",
            { staticClass: "mb-3" },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { xs12: "", md4: "" } },
                        [
                          _c(
                            "v-layout",
                            { attrs: { row: "", wrap: "" } },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c("v-select", {
                                    attrs: {
                                      dense: "",
                                      items: _vm.periods,
                                      label: _vm._f("cap")(_vm.$t("period")),
                                      "prepend-icon": "date_range",
                                      disabled: _vm.periodDisabled
                                    },
                                    model: {
                                      value: _vm.period,
                                      callback: function($$v) {
                                        _vm.period = $$v
                                      },
                                      expression: "period"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm6: "" } },
                                [
                                  _c(
                                    "v-dialog",
                                    {
                                      attrs: {
                                        lazy: "",
                                        "full-width": "",
                                        width: "290px",
                                        disabled: _vm.period != 0
                                      },
                                      model: {
                                        value: _vm.modalStart,
                                        callback: function($$v) {
                                          _vm.modalStart = $$v
                                        },
                                        expression: "modalStart"
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          slot: "activator",
                                          label: _vm._f("cap")(
                                            _vm.$t("startDate")
                                          ),
                                          "prepend-icon": "event",
                                          readonly: "",
                                          disabled: _vm.period != 0
                                        },
                                        on: {
                                          blur: function($event) {
                                            _vm.dateStartPicker = _vm.parseDate(
                                              _vm.dateStartDisplayed
                                            )
                                          }
                                        },
                                        slot: "activator",
                                        model: {
                                          value: _vm.dateStartDisplayed,
                                          callback: function($$v) {
                                            _vm.dateStartDisplayed = $$v
                                          },
                                          expression: "dateStartDisplayed"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-date-picker", {
                                        attrs: {
                                          "first-day-of-week": 1,
                                          min: _vm.allowedDatesStart.min,
                                          max: _vm.allowedDatesStart.max,
                                          locale: _vm.$i18n.locale,
                                          scrollable: "",
                                          color: "primary"
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.dateStartDisplayed = _vm.formatDate(
                                              $event
                                            )
                                            _vm.modalStart = false
                                          }
                                        },
                                        model: {
                                          value: _vm.dateStartPicker,
                                          callback: function($$v) {
                                            _vm.dateStartPicker = $$v
                                          },
                                          expression: "dateStartPicker"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { xs12: "", sm6: "" } },
                                [
                                  _c(
                                    "v-dialog",
                                    {
                                      attrs: {
                                        "full-width": "",
                                        scrollable: "",
                                        "max-width": "300px",
                                        disabled: _vm.period != 0
                                      },
                                      model: {
                                        value: _vm.modalEnd,
                                        callback: function($$v) {
                                          _vm.modalEnd = $$v
                                        },
                                        expression: "modalEnd"
                                      }
                                    },
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          slot: "activator",
                                          label: _vm._f("cap")(
                                            _vm.$t("endDate")
                                          ),
                                          "prepend-icon": "event",
                                          readonly: "",
                                          disabled: _vm.period != 0
                                        },
                                        on: {
                                          blur: function($event) {
                                            _vm.dateEndPicker = _vm.parseDate(
                                              _vm.dateEndDisplayed
                                            )
                                          }
                                        },
                                        slot: "activator",
                                        model: {
                                          value: _vm.dateEndDisplayed,
                                          callback: function($$v) {
                                            _vm.dateEndDisplayed = $$v
                                          },
                                          expression: "dateEndDisplayed"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-date-picker", {
                                        attrs: {
                                          "first-day-of-week": 1,
                                          min: _vm.allowedDatesEnd.min,
                                          max: _vm.allowedDatesEnd.max,
                                          locale: _vm.$i18n.locale,
                                          scrollable: "",
                                          color: "primary"
                                        },
                                        on: {
                                          input: function($event) {
                                            _vm.dateEndDisplayed = _vm.formatDate(
                                              $event
                                            )
                                            _vm.modalEnd = false
                                          }
                                        },
                                        model: {
                                          value: _vm.dateEndPicker,
                                          callback: function($$v) {
                                            _vm.dateEndPicker = $$v
                                          },
                                          expression: "dateEndPicker"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.$route.name !== "sales" || !_vm.HAS_ONE_FUNNEL
                        ? _c(
                            "v-flex",
                            { attrs: { xs6: "", md2: "" } },
                            [
                              _c(
                                "v-layout",
                                { attrs: { row: "", wrap: "" } },
                                [
                                  _c(
                                    "v-flex",
                                    {
                                      class: {
                                        "ml-5": _vm.$vuetify.breakpoint.mdAndUp
                                      },
                                      attrs: { xs12: "", "pt-2": "" }
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          staticClass: "ml-0",
                                          attrs: {
                                            color: "primary",
                                            outline: "",
                                            block:
                                              _vm.$vuetify.breakpoint.smAndDown
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.openDialogSites()
                                            }
                                          }
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            {
                                              attrs: {
                                                left: "",
                                                color: "primary"
                                              }
                                            },
                                            [_vm._v("language")]
                                          ),
                                          _vm._v(" "),
                                          _vm.$vuetify.breakpoint.xsOnly
                                            ? _c("div", [
                                                _vm._v(
                                                  _vm._s(_vm.site.length) +
                                                    " / " +
                                                    _vm._s(
                                                      _vm.$store.state._Sites
                                                        .sites.length
                                                    )
                                                )
                                              ])
                                            : _c("div", [
                                                _vm._v(
                                                  _vm._s(_vm.site.length) +
                                                    " / " +
                                                    _vm._s(
                                                      _vm.$tc(
                                                        "sites",
                                                        _vm.$store.state._Sites
                                                          .sites.length,
                                                        {
                                                          count:
                                                            _vm.$store.state
                                                              ._Sites.sites
                                                              .length
                                                        }
                                                      )
                                                    )
                                                )
                                              ])
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-dialog",
                                        {
                                          attrs: {
                                            scrollable: "",
                                            persistent: "",
                                            "max-width": "min-content"
                                          },
                                          model: {
                                            value: _vm.dialogSites,
                                            callback: function($$v) {
                                              _vm.dialogSites = $$v
                                            },
                                            expression: "dialogSites"
                                          }
                                        },
                                        [
                                          _c(
                                            "v-card",
                                            [
                                              _c(
                                                "v-card-title",
                                                {
                                                  staticClass:
                                                    "primary white--text"
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    { staticClass: "headline" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$t("select") +
                                                            " " +
                                                            _vm.$tc(
                                                              "sites",
                                                              2,
                                                              { count: "" }
                                                            )
                                                        )
                                                      )
                                                    ]
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("v-divider"),
                                              _vm._v(" "),
                                              _c(
                                                "v-card-text",
                                                {
                                                  staticStyle: {
                                                    height: "400px"
                                                  }
                                                },
                                                [
                                                  _c("v-data-table", {
                                                    staticClass: "elevation-1",
                                                    attrs: {
                                                      headers: _vm.headersSites,
                                                      items:
                                                        _vm.$store.state._Sites
                                                          .sites,
                                                      "item-key": "LIC_ID",
                                                      "select-all": "primary",
                                                      "hide-actions": "",
                                                      "total-items":
                                                        _vm.$store.state._Sites
                                                          .sites.length
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "headerCell",
                                                          fn: function(props) {
                                                            return [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "subheading"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      props
                                                                        .header
                                                                        .text
                                                                    )
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          }
                                                        },
                                                        {
                                                          key: "items",
                                                          fn: function(props) {
                                                            return [
                                                              _c(
                                                                "td",
                                                                [
                                                                  _c(
                                                                    "v-checkbox",
                                                                    {
                                                                      attrs: {
                                                                        color:
                                                                          "primary"
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          props.selected,
                                                                        callback: function(
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            props,
                                                                            "selected",
                                                                            $$v
                                                                          )
                                                                        },
                                                                        expression:
                                                                          "props.selected"
                                                                      }
                                                                    }
                                                                  )
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c("td", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    props.item
                                                                      .LIC_URL
                                                                  )
                                                                )
                                                              ])
                                                            ]
                                                          }
                                                        }
                                                      ],
                                                      null,
                                                      false,
                                                      3296734158
                                                    ),
                                                    model: {
                                                      value: _vm.siteTmp,
                                                      callback: function($$v) {
                                                        _vm.siteTmp = $$v
                                                      },
                                                      expression: "siteTmp"
                                                    }
                                                  })
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c("v-divider"),
                                              _vm._v(" "),
                                              _c(
                                                "v-card-actions",
                                                [
                                                  _c("v-spacer"),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: { flat: "" },
                                                      nativeOn: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          _vm.dialogSites = false
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.$t("cancel"))
                                                      )
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "v-btn",
                                                    {
                                                      attrs: {
                                                        disabled: !_vm.siteTmp
                                                          .length,
                                                        color: "primary"
                                                      },
                                                      nativeOn: {
                                                        click: function(
                                                          $event
                                                        ) {
                                                          return _vm.submitDialogSites()
                                                        }
                                                      }
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(_vm.$t("submit"))
                                                      )
                                                    ]
                                                  )
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showSelectMotifs
                        ? _c(
                            "v-flex",
                            { attrs: { xs6: "", md2: "" } },
                            [
                              _c("wz-select-motifs", {
                                attrs: {
                                  motifs: _vm.motif,
                                  motifsInit: _vm.motifInitialisation
                                },
                                on: {
                                  "update:motifs": function($event) {
                                    _vm.motif = $event
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showSelectAgents
                        ? _c(
                            "v-flex",
                            { attrs: { xs6: "", md2: "" } },
                            [
                              _c("wz-select-agents", {
                                attrs: {
                                  agents: _vm.agent,
                                  agentsInit: _vm.$store.state._User.colleagues,
                                  min: 1
                                },
                                on: {
                                  "update:agents": function($event) {
                                    _vm.agent = $event
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showSelectBots
                        ? _c(
                            "v-flex",
                            { attrs: { xs6: "", md2: "" } },
                            [
                              _c("wz-select-bots", {
                                attrs: {
                                  bot: _vm.bot,
                                  listeBots: _vm.$store.state._User.bots,
                                  testChatbot: _vm.showBotTester
                                },
                                on: {
                                  "update:bot": function($event) {
                                    _vm.bot = $event
                                  }
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "transition",
        { attrs: { name: "slide-x-reverse-transition", mode: "out-in" } },
        [_c("router-view")],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7337491f", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7337491f","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stats.vue
// module id = null
// module chunks = 